<div class="" style="padding: 5px">
  <form fxLayout="column" [formGroup]="registerForm">
    <mat-form-field appearance="outline" class="medium-error">
      <mat-label>نام و نام خانوادگی</mat-label>
      <input
        placeholder="مانند : مهدی رحیمی"
        formControlName="fullName"
        required
        type="text"
        matInput
      />
      <jam-icon matSuffix name="mask"></jam-icon>
      <mat-error
        *ngIf="(fullNameField.touched || fullNameField.dirty) && fullNameField.errors?.['required']"
      >
        نام و نام خانوادگی الزامی است
      </mat-error>
      <mat-error
        *ngIf="fullNameField.dirty && fullNameField.errors?.['minlength']"
      >
        نام و نام خانوادگی باید حد اقل
        {{ fullNameField.errors?.['minlength'].requiredLength | digitsEnToFa }}
        کاراکتر باشد
      </mat-error>
      <mat-error
        *ngIf="fullNameField.dirty && fullNameField.errors?.['isPersian'] && !fullNameField.errors?.['required'] && !fullNameField.errors?.['minlength']"
      >
        نام و نام خانوادگی باید متشکل از حروف فارسی باشد
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="medium-error">
      <mat-label>تلفن همراه</mat-label>
      <input
        [value]="phoneField.value"
        placeholder="مانند 09167896325"
        formControlName="phone"
        required
        type="text"
        matInput
        dir="ltr"
      />
      <jam-icon
        matSuffix
        *ngIf="
          !_checkingPhoneNumber && !phoneField.valid && phoneField.untouched
        "
        name="phone"
      />
      <jam-icon
        matSuffix
        *ngIf="!_checkingPhoneNumber && !phoneField.valid && phoneField.touched"
        name="close"
        color="warn"
      />
      <jam-icon
        matSuffix
        *ngIf="phoneField.valid && !_checkingPhoneNumber"
        name="check"
        style="color: green"
      />
      <mat-spinner
        [diameter]="15"
        *ngIf="_checkingPhoneNumber"
        matSuffix
        class="mat-spinner-formfield"
        style="margin-left: 3px; margin-right: 9px"
      />
      <mat-error
        *ngIf="
          registerForm.dirty &&
          !registerForm.valid &&
          phoneField.dirty &&
          phoneField.hasError('required')
        "
      >
        شماره تلفن همراه الزامی است
      </mat-error>
      <mat-error
        *ngIf="registerForm.dirty && !registerForm.valid && !phoneField.hasError('required') && phoneField.dirty && phoneField.errors?.['pattern']"
      >
        شماره تلفن وارد شده قابل تایید نیست
      </mat-error>
      <mat-error
        *ngIf="
          registerForm.dirty &&
          !registerForm.valid &&
          phoneField.dirty &&
          phoneField.hasError('phoneExists')
        "
      >
        شماره تلفن {{ phoneField.value }} قبلا استفاده شده است
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="medium-error">
      <mat-label>رمز عبور</mat-label>
      <input
        formControlName="password"
        dir="ltr"
        required
        type="password"
        matInput
        (keyup)="checkRepeatPassword()"
        (change)="checkRepeatPassword()"
      />
      <jam-icon matSuffix name="key" />
      <mat-error
        *ngIf="registerForm.dirty && !registerForm.valid && passwordField.dirty && passwordField.errors?.['required']"
      >
        رمز عبور الزامی است
      </mat-error>
      <mat-error
        *ngIf="registerForm.dirty && !registerForm.valid && passwordField.errors?.['minlength']"
      >
        حد اقل طول رمز عبور
        {{ passwordField.errors?.['minlength'].requiredLength | digitsEnToFa }}
        حرف است
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="medium-error">
      <mat-label>تکرار رمز عبور</mat-label>
      <input
        formControlName="confirmPassword"
        dir="ltr"
        required
        type="password"
        matInput
        (keyup)="checkRepeatPassword()"
        (change)="checkRepeatPassword()"
      />
      <jam-icon matSuffix name="repeat"></jam-icon>
      <mat-error
        *ngIf="
          registerForm.dirty &&
          confirmPassword.hasError('confirmPass') &&
          !confirmPassword.hasError('required') &&
          confirmPassword.dirty
        "
      >
        رمز عبور و تکرار آن تطابق ندارند
      </mat-error>
      <mat-error
        *ngIf="
          registerForm.dirty &&
          confirmPassword.hasError('required') &&
          confirmPassword.dirty
        "
      >
        تکرار رمز عبور الزامی است
      </mat-error>
    </mat-form-field>
  </form>

  <!-- Form actions -->
  <div class="form-actions" fxLayout="row" fxLayoutAlign="start start">
    <button
      mat-button
      color="primary"
      mat-raised-button
      [disabled]="registerForm.invalid || _checkingPhoneNumber"
      (click)="onSubmitRegister()"
    >
      ثبت نام
    </button>
    <!-- <button
      class="refresh-btn"
      mat-button
      color="warn"
      (click)="registerForm.reset()"
    >
      تازه سازی <jam-icon name="refresh"></jam-icon>
    </button> -->
  </div>
</div>
